import { fold } from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import { z } from 'zod';

import { ERROR } from '../../constants/ReactQueryAPIConstants';

export const getLastSubstringBasedOnChar = (
  dataString: string,
  char: string
): Array<string> => {
  const index = dataString.lastIndexOf(char);
  if (index === -1) {
    return [dataString, ''];
  } else {
    return [dataString.slice(0, index), dataString.slice(index + 1)];
  }
};

export function decodeTheStringifyContent(
  extraData: string,
  dataType: t.TypeC<any>
) {
  const onLeft = (errors: t.Errors) => {
    return ERROR;
  };
  const onRight = (s: any) => {
    return s;
  };

  try {
    const parsedData = JSON.parse(extraData);
    return pipe(dataType.decode(parsedData), fold(onLeft, onRight));
  } catch (error) {
    return ERROR; // Return ERROR for invalid JSON
  }
}

export function decodeTheZodStringifyContent(
  extraData: string,
  schema: z.ZodType<any>
) {
  try {
    const parsedData = JSON.parse(extraData);
    const result = schema.safeParse(parsedData);

    return result.success ? result.data : ERROR;
  } catch (error) {
    return ERROR;
  }
}

export const trimStringToLength = (
  str: string,
  length: number,
  start = 0
): string => {
  return str.length > length ? str.slice(start, length) : str;
};

export const normalizeStringOrNull = (value?: string | null): string | null => {
  if (value == null || value.trim() === '') {
    return null;
  }
  return value.trim();
};

export const isValidUserName = (name: string): boolean =>
  name && name !== '' ? true : false;

export const userStringsLength = (userStrings: string[]): number =>
  userStrings.length;

export const getFirstAlphabet = (userStrings: string[]): string =>
  userStrings[0][0].toUpperCase();

export const getFirstSecondAlphabet = (userStrings: string[]): string => {
  const length = userStringsLength(userStrings);
  const firstAlphabet = userStrings[0][0];
  const lastAlphabet = userStrings[length - 1][0];
  const userName = firstAlphabet + lastAlphabet;
  return userName.toUpperCase();
};

export const getWordFirstSecondAlphabets = (userStrings: string[]): string => {
  if (userStrings[0].length > 1) {
    return userStrings[0][0].toUpperCase() + userStrings[0][1].toUpperCase();
  }
  return getFirstAlphabet(userStrings);
};

export const getUserName = (name: string): string => {
  if (isValidUserName(name)) {
    const userName = name.trim();
    const userStrings = userName.split(' ');
    const length = userStringsLength(userStrings);
    if (length === 1) {
      return getWordFirstSecondAlphabets(userStrings);
    }
    return getFirstSecondAlphabet(userStrings);
  }
  return '';
};
